import { FileText } from "lucide-react";
import Button from "../../../../components/controls/button/Button";

const ReportButton = ({ onClick, loading }) => (
  <Button
    btnClass="d_btn d_btn_primary ms-auto"
    label={loading ? "Generating..." : "Generate Report"}
    icon={<FileText size={14} />}
    showLoading={loading}
    isDisabled={loading}
    clickHandler={onClick}
  />
);

export default ReportButton;
